import { errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Platform console: delivery partners, per-site revenue split, hosting status, Connect onboarding. */
export class PartnerViewModel extends ViewModel {
    client;
    constructor(client) {
        super({
            partners: [],
            sitePartners: null,
            hosting: null,
            error: null,
            hostingError: null,
            saving: false,
            message: null,
        });
        this.client = client;
    }
    /** Partners + this site's split in one shot; hosting status loads independently. */
    async loadSplit(slug) {
        const split = Promise.all([this.client.listPartners(), this.client.getSitePartners(slug)]).then(([partners, sitePartners]) => this.setState({ partners, sitePartners }), (e) => this.setState({ error: errorMessage(e, "Failed to load partner split") }));
        const hosting = this.client.getHostingStatus(slug).then((h) => this.setState({ hosting: h }), (e) => this.setState({ hostingError: errorMessage(e, "Could not load hosting status") }));
        await Promise.all([split, hosting]);
    }
    async saveSplit(slug, input) {
        this.setState({ message: null, error: null, saving: true });
        try {
            const sitePartners = await this.client.putSitePartners(slug, input);
            this.setState({ sitePartners, message: "Split saved.", saving: false });
        }
        catch (e) {
            this.setState({ error: errorMessage(e, "Failed to save split"), saving: false });
        }
    }
    /** Throws on failure so the form can show its own status. */
    createPartner(input) {
        return this.client.createPartner(input);
    }
    startConnectOnboarding(slug, returnUrl) {
        return this.client.startConnectOnboarding(slug, returnUrl, returnUrl);
    }
    /** Stripe onboarding flag for one partner; `null` when unknown or the list fails. */
    async partnerConnectReady(slug) {
        try {
            const ps = await this.client.listPartners();
            return ps.find((p) => p.slug === slug)?.connectReady ?? null;
        }
        catch {
            return null;
        }
    }
}
//# sourceMappingURL=PartnerViewModel.js.map